import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import EmailDetails from './form/EmailDetails.js';
import Notification from '../../components/Notification.js';
import GeneralHandler from '../../modules/General';
import General from '../../helpers/General';
import {setSetting} from '../../actions/General.js';
import Switch from 'rc-switch';

import Dropzone from 'react-dropzone';
import LoadingSmall from '../../components/LoadingSmall';
import CompanyDetails from "./form/CampanyDetails";
import NewsletterListPicker from '../../components/NewsletterListPicker.js';
import Helpers from "../../helpers/General";

class SettingsEmails extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
            isUploading:false,
			isLoading:true,
			isSavingDetails:false,
			blacklistCount:0,
			blacklist_email:'',
		}

		this.handleSubmit = this.handleSubmit.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onOpenClick = this.onOpenClick.bind(this);
        this.sendVerification = this.sendVerification.bind(this);
        this.switchBackupServerStatus = this.switchBackupServerStatus.bind(this);
        this.handleDetails = this.handleDetails.bind(this);
	}

    switchBackupServerStatus(val) {
        this.props.setSetting('BACKUP_EMAIL_STATUS',val);

        axios.post('/ajax/backup_email_server',{
			status:val
        }).then(res => {
            Notification.success('Success');
        });
	}

	handleBlacklistEmailChange = (e) => {
		this.setState({
			blacklist_email:e.target.value,
		});
	}

	blacklistEmail = () => {
		if(!General.validateEmail(this.state.blacklist_email)) {
			Notification.error('Invalid e-mail address');
			return;
		}

		this.setState({
			blacklist_email:''
		});

		axios.post('/blacklist',{
			email:this.state.blacklist_email
		}).then((res) => {
			Notification.success('E-mail added to blacklist');
		});
	}

    sendVerification() {
		axios.post('/ajax/send_verification',{

		}).then(res => {
            if(res.data.status == 'EXIST') {
                Notification.info('E-mail already verified');
            }else{
                Notification.success('Verification sent');
            }

		});
	}

	handleGrabberChange = (e) => {
		this.props.setSetting(e.target.getAttribute('data-key'),e.target.value);
    }

    saveGrabberData = () => {
        let data = {
            EMAIL_LOOKUP_STATUS:this.props.general.settings.EMAIL_LOOKUP_STATUS,
            EMAIL_LOOKUP_BTN_DECLINE:this.props.general.settings.EMAIL_LOOKUP_BTN_DECLINE,
            EMAIL_LOOKUP_BTN_ACCEPT:this.props.general.settings.EMAIL_LOOKUP_BTN_ACCEPT,
            EMAIL_LOOKUP_TEXT_BODY:this.props.general.settings.EMAIL_LOOKUP_TEXT_BODY,
            EMAIL_LOOKUP_TEXT_HEADER:this.props.general.settings.EMAIL_LOOKUP_TEXT_HEADER,
		};

		axios.put('/settings',data).then(res => {
            Notification.success('Success!');
        }).catch(err => {
			Notification.error('Error!');

        });
	}


    onDrop(files) {
        if(files.length == 0) {
            return;
        }

        this.setState({isUploading:true});

        let data = new FormData();
        data.append('file', files[0]);

        axios.post('/blacklist/upload',data)
            .then(res => {
                this.setState({isUploading:false});
                axios.get('/blacklist/stats').then(res => {
                    this.setState({blacklistCount:res.data.count});
                });
            }).catch(err => {
            this.setState({isUploading:false});
        });
    }

    onOpenClick() {
        this.refs.dropzone.open();
    }



	handleSubmit(values) {
		this.setState({
			isSavingDetails:true
		});

		let data = {
			EMAIL_SENDER_NAME:values.name,
			EMAIL_SENDER_EMAIL:values.email,
		};

		axios.put('/settings',data).then(res => {
			this.setState({
				isSavingDetails:false
			});
			this.props.setSetting('EMAIL_SENDER_NAME',values.name);
			this.props.setSetting('EMAIL_SENDER_EMAIL',values.email);

			Notification.success('Success!');
		}).catch(err => {
			this.setState({
				isSavingDetails:false
			});
		});
	}

    handleDetails(data) {
        this.setState({
            isSavingDetails:true
        });


        axios.put('/settings',data).then(res => {
            this.setState({
                isSavingDetails:false
            });

            Notification.success('Success!');
        }).catch(err => {
            this.setState({
                isSavingDetails:false
            });
        });
    }

	handleNewsletterSave = (data) => {
		axios.put('/account/newsletter_integration',data).then(res => {
			Notification.success('Success!');

			this.props.setSetting('ESP_INTEGRATION',data)
		}).catch(err => {
		});
	}

	componentWillMount() {
		GeneralHandler.fetchGeneral().then(() => {
            axios.get('/blacklist/stats').then(res => {
                this.setState({isLoading:false,blacklistCount:res.data.count});
            });

		});


	}

	getNewsletterSettings = () => {
		if(!this.props.general.settings.ESP_INTEGRATION || this.props.general.settings.ESP_INTEGRATION == '') {
			return {};
		}

		let data = JSON.parse(this.props.general.settings.ESP_INTEGRATION);

		return data;
	}

	render() {

		if(this.state.isLoading) {
			return <Loading error={false} />
		}

		return (
			<div className="full-height">
				<Helmet title="E-mails | Crall.io" />
				<div className="page-header">
					<span className="page-title"><i className="icon wb-envelope"></i> E-mails</span>
				</div>

				<div className="page-content">

				<OptionColumn title="Sender" description="This values will be displayed to your e-mail recipients.">
					<EmailDetails isSavingDetails={this.state.isSavingDetails} onSubmit={this.handleSubmit} />
				</OptionColumn>

				<OptionColumn title="Required footer details" description="This information will be visible in the e-mail footer. Empty fields will default to your billing information.">
					<CompanyDetails isSavingDetails={this.state.isSavingDetails} onSubmit={this.handleDetails} />
				</OptionColumn>

				<SplitRows />

				<OptionColumn title="E-mail grabber" description="Settings related to e-mail grabber popup">
						<div className="form-group col-sm-12">
                            <div className="col-sm-6">
                                <h5>Status</h5>
                                <div className="col-sm-12 text-center">
                                    Off &nbsp;&nbsp;
                                    <Switch onChange={(val) => { if(val == 'true' || val === true) {val='1';}else{val='0';}  this.props.setSetting('EMAIL_LOOKUP_STATUS',val) } }
                                            checked={(this.props.general.settings.EMAIL_LOOKUP_STATUS == '1' || this.props.general.settings.EMAIL_LOOKUP_STATUS === 1  ? true:false)}
                                            checkedChildren={<i className="icon fa-check"></i>}
                                            unCheckedChildren={<i className="icon fa-close"></i>}
                                    /> &nbsp;On
                                </div>
                            </div>

                            <div className="form-group col-sm-6">
								<div className="alert alert-info alert-dismissible" role="alert">
									When "E-mail grabber" is activated Crall will automatically search and collect e-mails from the visitor. If we detect an e-mail we'll display a popup asking the customer if they accept us to user their e-mail.
								</div>
                            </div>

                        </div>

						<h5>Translations</h5>

						<table className="table table-striped">
							<tbody>
								<tr>
									<td>Header text</td>
									<td><input type="text" data-key="EMAIL_LOOKUP_TEXT_HEADER" onChange={this.handleGrabberChange} value={this.props.general.settings.EMAIL_LOOKUP_TEXT_HEADER} className="form-control" /></td>
								</tr>
								<tr>
									<td>Body text</td>
									<td><input type="text" data-key="EMAIL_LOOKUP_TEXT_BODY" onChange={this.handleGrabberChange} value={this.props.general.settings.EMAIL_LOOKUP_TEXT_BODY} className="form-control" /></td>
								</tr>
								<tr>
									<td>Accept button</td>
									<td><input type="text" data-key="EMAIL_LOOKUP_BTN_ACCEPT" onChange={this.handleGrabberChange} value={this.props.general.settings.EMAIL_LOOKUP_BTN_ACCEPT} className="form-control" /></td>
								</tr>
								<tr>
									<td>Decline button</td>
									<td><input type="text" data-key="EMAIL_LOOKUP_BTN_DECLINE" onChange={this.handleGrabberChange} value={this.props.general.settings.EMAIL_LOOKUP_BTN_DECLINE} className="form-control" /></td>
								</tr>
							</tbody>
						</table>


                        <div className="col-sm-12 m-t-20">
                            <button type="button" onClick={this.saveGrabberData} className="btn btn-dark btn-block">Save</button>
                        </div>
				</OptionColumn>

				<SplitRows />
					<OptionColumn title="Newsletter integration" description="Transfer e-mails collected by Crall to your ESP.">
						<NewsletterListPicker data={this.getNewsletterSettings()} handleSave={this.handleNewsletterSave} inputs={[{
							id:'email',
							styles:{
								placeholder:"E-mail",
							},
							type:'crall-input',
						}]} apps={GeneralHandler.appGetType('newsletter')} />

					</OptionColumn>
				<SplitRows />

				<OptionColumn title="Blacklist" description="Import blacklisted e-mail addresses">
					<div className="col-sm-4">
						<div className="col-sm-12">
							<div className="card card-block p-0 m-0">
								<div className="counter counter-lg">
									<span className="counter-number">{this.state.blacklistCount}</span>
									<div className="counter-label text-uppercase">Blacklisted e-mails</div>
								</div>
							</div>
						</div>
					</div>

					<div className="col-sm-8 text-center">
						<p>
							If you have an existing e-mail blacklist and you wan't to ignore them in Crall. Please upload a CSV file containing only e-mails you wish to ignore.
						</p>
						<Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
                            {
                                this.state.isUploading ?
									<LoadingSmall />
                                    :
									<button type="button" onClick={this.onOpenClick} className="btn btn-dark">Upload blacklist</button>
                            }
						</Dropzone>

						<SplitRows />

						You can also add a single e-mails address to the blacklist without uploading a file.<br /><br />
						<div className="row">
							<div className="col-sm-8">
								<input type="text" value={this.state.blacklist_email} onChange={this.handleBlacklistEmailChange} placeholder="someone@example.com" className="form-control" />
							</div>
							<div className="col-sm-4">
								<button onClick={this.blacklistEmail} className="btn btn-dark pull-right">Add e-mail to blacklist</button>
							</div>
						</div>
					</div>
				</OptionColumn>

				<SplitRows />

				<OptionColumn title="Advanced setting" description="Use an alternative e-mailserver for order confirmations.">
					<div className="col-sm-5">
						<h5>Status</h5>
						<div className="alert dark alert-icon alert-warning alert-dismissible" role="alert">
							<i className="icon wb-alert" aria-hidden="true"></i> Before turning this feature on, you must complete the verification process to the right.
						</div>
						<div className="col-sm-12 text-center">
							Off &nbsp;&nbsp;
							<Switch onChange={this.switchBackupServerStatus}
									checked={(this.props.general.settings.BACKUP_EMAIL_STATUS == '1' ? true:false)}
									checkedChildren={<i className="icon fa-check"></i>}
									unCheckedChildren={<i className="icon fa-close"></i>}
							/> &nbsp;On
						</div>
					</div>

					<div className="col-sm-7">
						<h5>Verification</h5>
						To start using this feature you must verify that you are the owner of <strong>"{this.props.general.settings.EMAIL_SENDER_EMAIL}"</strong>.
						When clicking the button we'll send a verification e-mail to <strong>"{this.props.general.settings.EMAIL_SENDER_EMAIL}"</strong>. In the e-mails there will be a button you must click.
						<strong>After clicking the link you can turn on this feature to the left.</strong><br /><br />

						<div className="col-sm-12 text-center">
							<button onClick={this.sendVerification} className="btn btn-dark">Send verification e-mail</button>
						</div>
					</div>
				</OptionColumn>




				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setSetting},dispatch)
}


SettingsEmails = connect(mapStateToProps,mapDispatchToProps)(SettingsEmails);
export default SettingsEmails;



// WEBPACK FOOTER //
// ./containers/settings/SettingsEmails.js